// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
}

tr th:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
}

tr.detail:hover {
  cursor: default;
}

tr.detail td {
  cursor: default;
}

.shadow-box {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    margin-top: 10px;
}

#filter_input:focus {
    outline: none !important;
    border-color:rgba(0, 0, 0, 0.24);
    box-shadow: 0 0 10px #deedfa;
}

.pointer.active.desc:after {
    content: " ▼";
    color: #390263;
}
.pointer.active.asc:after {
    content: " ▲";
    color: #02661d
    
}


.shadow-box-2 {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    padding: 10px;
    margin: 10px;
    border-radius: 10px;
    margin-top: 10px;
    display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;
}

:host ::ng-deep .mat-form-field {
    font-family: garamond !important;
    color: black;
    font-weight: 400;
  }
  
:host ::ng-deep .mat-form-field-wrapper {
padding-bottom: 0px;
}

:host ::ng-deep .mat-form-field-flex{
padding: 0px !important;
}

:host ::ng-deep .mat-select-value{
text-align:center
}


:host ::ng-deep .mat-form-field-underline {
display: none;
}

.no-style tr {
    background-color: transparent;
}
.no-style {
border: none;
}

.no-style th,
.no-style td {
    border: none;
    padding: 0px;
    padding-right: 8px;
    margin: 0px
}

.no-style thead th,
.no-style thead td {
    border-bottom-width: 2px;
}
.link-active {
    text-decoration: underline;
    color: blue;  /* Choose the color you prefer */
    cursor: pointer;  /* Add a pointer cursor to indicate it's clickable */
  }
  `, "",{"version":3,"sources":["webpack://./src/app/clients/clients.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,wFAAwF;IACxF,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,aAAa;IACb;;AAEJ;;;AAGA;IACI,wFAAwF;IACxF,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,CAAC,qBAAqB,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB;AACvI;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;EAClB;;AAEF;AACA,mBAAmB;AACnB;;AAEA;AACA,uBAAuB;AACvB;;AAEA;AACA;AACA;;;AAGA;AACA,aAAa;AACb;;AAEA;IACI,6BAA6B;AACjC;AACA;AACA,YAAY;AACZ;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;IAC1B,WAAW,GAAG,gCAAgC;IAC9C,eAAe,GAAG,oDAAoD;EACxE","sourcesContent":["tr:hover {\n    cursor: pointer;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 10px;\n}\n\ntr th:hover {\n    cursor: pointer;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    border-radius: 10px;\n}\n\ntr.detail:hover {\n  cursor: default;\n}\n\ntr.detail td {\n  cursor: default;\n}\n\n.shadow-box {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n}\n\n#filter_input:focus {\n    outline: none !important;\n    border-color:rgba(0, 0, 0, 0.24);\n    box-shadow: 0 0 10px #deedfa;\n}\n\n.pointer.active.desc:after {\n    content: \" ▼\";\n    color: #390263;\n}\n.pointer.active.asc:after {\n    content: \" ▲\";\n    color: #02661d\n    \n}\n\n\n.shadow-box-2 {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    padding: 10px;\n    margin: 10px;\n    border-radius: 10px;\n    margin-top: 10px;\n    display: flex; align-items: center; justify-content: center;font-family: garamond; color: black; font-size:medium; font-weight: 600;\n}\n\n:host ::ng-deep .mat-form-field {\n    font-family: garamond !important;\n    color: black;\n    font-weight: 400;\n  }\n  \n:host ::ng-deep .mat-form-field-wrapper {\npadding-bottom: 0px;\n}\n\n:host ::ng-deep .mat-form-field-flex{\npadding: 0px !important;\n}\n\n:host ::ng-deep .mat-select-value{\ntext-align:center\n}\n\n\n:host ::ng-deep .mat-form-field-underline {\ndisplay: none;\n}\n\n.no-style tr {\n    background-color: transparent;\n}\n.no-style {\nborder: none;\n}\n\n.no-style th,\n.no-style td {\n    border: none;\n    padding: 0px;\n    padding-right: 8px;\n    margin: 0px\n}\n\n.no-style thead th,\n.no-style thead td {\n    border-bottom-width: 2px;\n}\n.link-active {\n    text-decoration: underline;\n    color: blue;  /* Choose the color you prefer */\n    cursor: pointer;  /* Add a pointer cursor to indicate it's clickable */\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
